/* eslint-disable max-lines */
export const surgeriesList = [
  {
    value: 'Adrenal Gland Surgery',
    label: 'Adrenal Gland Surgery'
  },
  {
    value: 'Appendectomy',
    label: 'Appendectomy'
  },
  {
    value: 'Bariatric Surgery',
    label: 'Bariatric Surgery'
  },
  {
    value: 'Bladder Surgery',
    label: 'Bladder Surgery'
  },
  {
    value: 'Breast Surgery',
    label: 'Breast Surgery'
  },
  {
    value: 'Cesarean Section',
    label: 'Cesarean Section'
  },
  {
    value: 'Cholecystectomy',
    label: 'Cholecystectomy'
  },
  {
    value: 'Colon Surgery',
    label: 'Colon Surgery'
  },
  {
    value: 'Coronary Artery Bypass Graft',
    label: 'Coronary Artery Bypass Graft'
  },
  {
    value: 'Esophagus Surgery',
    label: 'Esophagus Surgery'
  },
  {
    value: 'Gastric Bypass Surgery',
    label: 'Gastric Bypass Surgery'
  },
  {
    value: 'Hemorrhoid Surgery',
    label: 'Hemorrhoid Surgery'
  },
  {
    value: 'Hernia Repair',
    label: 'Hernia Repair'
  },
  {
    value: 'Hysterectomy',
    label: 'Hysterectomy'
  },
  {
    value: 'Kidney Surgery',
    label: 'Kidney Surgery'
  },
  {
    value: 'Neck Surgery',
    label: 'Neck Surgery'
  },
  {
    value: 'Prostate Surgery',
    label: 'Prostate Surgery'
  },
  {
    value: 'Small Intestine Surgery',
    label: 'Small Intestine Surgery'
  },
  {
    value: 'Spine Surgery',
    label: 'Spine Surgery'
  },
  {
    value: 'Stomach Surgery',
    label: 'Stomach Surgery'
  },
  {
    value: 'Thyroid Surgery',
    label: 'Thyroid Surgery'
  }
];

export const allergies = [
  { label: 'Peanuts', value: 'Peanuts' },
  { label: 'Tree nuts', value: 'Tree nuts' },
  { label: 'Milk', value: 'Milk' },
  { label: 'Egg', value: 'Egg' },
  { label: 'Wheat', value: 'Wheat' },
  { label: 'Soy', value: 'Soy' },
  { label: 'Fish', value: 'Fish' },
  { label: 'Shellfish', value: 'Shellfish' },
  { label: 'Dust mites', value: 'Dust mites' },
  { label: 'Pet dander', value: 'Pet dander' },
  { label: 'Mold', value: 'Mold' },
  { label: 'Pollen', value: 'Pollen' },
  { label: 'Insect sting', value: 'Insect sting' },
  { label: 'Latex', value: 'Latex' },
  { label: 'Penicillin', value: 'Penicillin' },
  { label: 'Sulfonamide Antibiotics', value: 'Sulfonamide Antibiotics' },
  { label: 'Aspirin', value: 'Aspirin' },
  { label: 'NSAIDs', value: 'NSAIDs' },
  { label: 'Chemical Additives', value: 'Chemical Additives' },
  { label: 'Cockroaches and Their Droppings', value: 'Cockroaches and Their Droppings' },
  { label: 'Perfumes and Cosmetics', value: 'Perfumes and Cosmetics' },
  { label: 'Nickel', value: 'Nickel' },
  { label: 'Gold', value: 'Gold' },
  { label: 'Formaldehyde', value: 'Formaldehyde' },
  { label: 'Cobalt', value: 'Cobalt' },
  { label: 'Chromium', value: 'Chromium' },
  { label: 'Sesame Seeds', value: 'Sesame Seeds' },
  { label: 'Sunscreen Chemicals', value: 'Sunscreen Chemicals' },
  { label: 'Hair Dye', value: 'Hair Dye' },
  { label: 'Certain Fruits and Vegetables', value: 'Certain Fruits and Vegetables' },
  { label: 'Certain Spices', value: 'Certain Spices' },
  { label: 'Cephalosporin Antibiotics', value: 'Cephalosporin Antibiotics' },
  { label: 'Tetracycline Antibiotics', value: 'Tetracycline Antibiotics' },
  { label: 'Quinolone Antibiotics', value: 'Quinolone Antibiotics' },
  { label: 'Macrolide Antibiotics', value: 'Macrolide Antibiotics' },
  { label: 'Aminoglycoside Antibiotics', value: 'Aminoglycoside Antibiotics' },
  { label: 'Fungal Allergens', value: 'Fungal Allergens' },
  { label: 'Balsam of Peru', value: 'Balsam of Peru' },
  { label: 'Acrylates', value: 'Acrylates' },
  { label: 'Fragrance Mix', value: 'Fragrance Mix' },
  { label: 'Paraben Preservatives', value: 'Paraben Preservatives' },
  { label: 'Epoxy Resin', value: 'Epoxy Resin' },
  { label: 'Neomycin', value: 'Neomycin' }
];

export const medications = [
  { label: 'Ibuprofen', value: 'Ibuprofen' },
  { label: 'Paracetamol', value: 'Paracetamol' },
  { label: 'Aspirin', value: 'Aspirin' },
  { label: 'Amoxicillin', value: 'Amoxicillin' },
  { label: 'Ciprofloxacin', value: 'Ciprofloxacin' },
  { label: 'Doxycycline', value: 'Doxycycline' },
  { label: 'Azithromycin', value: 'Azithromycin' },
  { label: 'Metformin', value: 'Metformin' },
  { label: 'Amlodipine', value: 'Amlodipine' },
  { label: 'Simvastatin', value: 'Simvastatin' },
  { label: 'Atorvastatin', value: 'Atorvastatin' },
  { label: 'Losartan', value: 'Losartan' },
  { label: 'Hydrochlorothiazide', value: 'Hydrochlorothiazide' },
  { label: 'Lisinopril', value: 'Lisinopril' },
  { label: 'Furosemide', value: 'Furosemide' },
  { label: 'Levothyroxine', value: 'Levothyroxine' },
  { label: 'Warfarin', value: 'Warfarin' },
  { label: 'Carvedilol', value: 'Carvedilol' },
  { label: 'Metoprolol', value: 'Metoprolol' },
  { label: 'Prednisone', value: 'Prednisone' },
  { label: 'Gabapentin', value: 'Gabapentin' },
  { label: 'Albuterol', value: 'Albuterol' },
  { label: 'Loratadine', value: 'Loratadine' },
  { label: 'Diphenhydramine', value: 'Diphenhydramine' },
  { label: 'Alprazolam', value: 'Alprazolam' },
  { label: 'Sertraline', value: 'Sertraline' },
  { label: 'Citalopram', value: 'Citalopram' },
  { label: 'Escitalopram', value: 'Escitalopram' },
  { label: 'Fluoxetine', value: 'Fluoxetine' },
  { label: 'Omeprazole', value: 'Omeprazole' },
  { label: 'Pantoprazole', value: 'Pantoprazole' },
  { label: 'Ranitidine', value: 'Ranitidine' },
  { label: 'Insulin Glargine', value: 'Insulin Glargine' },
  { label: 'Insulin Lispro', value: 'Insulin Lispro' },
  { label: 'Insulin Aspart', value: 'Insulin Aspart' },
  { label: 'Atenolol', value: 'Atenolol' },
  { label: 'Clonazepam', value: 'Clonazepam' },
  { label: 'Propranolol', value: 'Propranolol' },
  { label: 'Latanoprost', value: 'Latanoprost' },
  { label: 'Tiotropium', value: 'Tiotropium' },
  { label: 'Salmeterol/Fluticasone', value: 'Salmeterol/Fluticasone' },
  { label: 'Budesonide/Formoterol', value: 'Budesonide/Formoterol' },
  { label: 'Duloxetine', value: 'Duloxetine' },
  { label: 'Venlafaxine', value: 'Venlafaxine' },
  { label: 'Quetiapine', value: 'Quetiapine' },
  { label: 'Risperidone', value: 'Risperidone' },
  { label: 'Olanzapine', value: 'Olanzapine' },
  { label: 'Lorazepam', value: 'Lorazepam' },
  { label: 'Diazepam', value: 'Diazepam' },
  { label: 'Morphine', value: 'Morphine' },
  { label: 'Oxycodone', value: 'Oxycodone' },
  { label: 'Hydrocodone/Acetaminophen', value: 'Hydrocodone/Acetaminophen' },
  { label: 'Tramadol', value: 'Tramadol' },
  { label: 'Fentanyl', value: 'Fentanyl' },
  { label: 'Pregabalin', value: 'Pregabalin' },
  { label: 'Amiodarone', value: 'Amiodarone' },
  { label: 'Digoxin', value: 'Digoxin' },
  { label: 'Nitroglycerin', value: 'Nitroglycerin' },
  { label: 'Clopidogrel', value: 'Clopidogrel' },
  { label: 'Ticagrelor', value: 'Ticagrelor' },
  { label: 'Prasugrel', value: 'Prasugrel' },
  { label: 'Apixaban', value: 'Apixaban' },
  { label: 'Rivaroxaban', value: 'Rivaroxaban' },
  { label: 'Dabigatran', value: 'Dabigatran' },
  { label: 'Statins', value: 'Statins' },
  { label: 'Benzodiazepines', value: 'Benzodiazepines' },
  { label: 'Beta blockers', value: 'Beta blockers' },
  { label: 'ACE inhibitors', value: 'ACE inhibitors' },
  {
    label: 'Angiotensin II receptor blockers (ARBs)',
    value: 'Angiotensin II receptor blockers (ARBs)'
  },
  { label: 'Calcium channel blockers', value: 'Calcium channel blockers' },
  { label: 'Diuretics', value: 'Diuretics' },
  { label: 'Antidepressants', value: 'Antidepressants' },
  { label: 'Antipsychotics', value: 'Antipsychotics' },
  { label: 'Anticonvulsants', value: 'Anticonvulsants' },
  { label: 'Ozempic', value: 'Ozempic' },
  { label: 'Semaglutide', value: 'Semaglutide' },
  { label: 'Tirzepatide', value: 'Tirzepatide' },
  {
    label: 'Other',
    value: 'Other'
  }
];

export const frequencyCode = [
  {
    label: '1',
    value: '1'
  },
  {
    label: '7',
    value: '7'
  },
  {
    label: '8',
    value: '8'
  }
];

export const frequencyListDefault = [
  {
    label: 'Day',
    value: 'Day'
  },
  {
    label: 'Week',
    value: 'Week'
  },
  {
    label: 'Month',
    value: 'Month'
  },
  {
    label: 'Year',
    value: 'Year'
  }
];

export const treatmentPlanProviderMethod = [
  {
    label: 'Individual Counseling',
    value: 'Individual Counseling'
  },
  {
    label: 'Medication Management',
    value: 'Medication Management'
  }
];

export const allergySeverities = [
  { label: 'Mild', value: 'Mild' },
  { label: 'Moderate', value: 'Moderate' },
  { label: 'Severe', value: 'Severe' }
];

export const typicalReactions = [
  {
    label: 'Anaphylaxis (severe)',
    value: 'Anaphylaxis (severe)'
  },
  {
    label: 'Hives',
    value: 'Hives'
  },
  {
    label: 'Rash',
    value: 'Rash'
  },
  {
    label: 'Tingling mouth',
    value: 'Tingling mouth'
  },
  {
    label: 'Swelling of lips',
    value: 'Swelling of lips'
  },
  {
    label: 'Vomiting',
    value: 'Vomiting'
  },
  {
    label: 'Abdominal Pain',
    value: 'Abdominal Pain'
  },
  {
    label: 'Tightness in throat (severe)',
    value: 'Tightness in throat (severe)'
  },
  {
    label: 'Difficulty/noisy breathing (severe)',
    value: 'Difficulty/noisy breathing (severe)'
  },
  {
    label: 'Difficulty talking/hoarse voice (severe)',
    value: 'Difficulty talking/hoarse voice (severe)'
  },
  {
    label: 'Swelling of tongue (severe)',
    value: 'Swelling of tongue (severe)'
  },
  {
    label: 'Swelling in throat (severe)',
    value: 'Swelling in throat (severe)'
  },
  {
    label: 'Persistent dizziness (severe)',
    value: 'Persistent dizziness (severe)'
  },
  {
    label: 'Collapse (severe)',
    value: 'Collapse (severe)'
  },
  {
    label: 'Pale and floppy (severe)',
    value: 'Pale and floppy (severe)'
  },
  {
    label: 'Wheezing (severe)',
    value: 'Wheezing (severe)'
  }
];

export const medicalConditions = [
  {
    label: 'Alcoholism',
    value: 'Alcoholism'
  },
  {
    label: "Alzheimer's Disease",
    value: "Alzhelmer's Disease"
  },
  {
    label: 'Amblyopia (lazy eye)',
    value: 'Amblyopia (lazy eye)'
  },
  {
    label: 'Anaphylaxis',
    value: 'Anaphylaxis'
  },
  {
    label: 'Anemia',
    value: 'Anemia'
  },
  {
    label: 'Aneurysm',
    value: 'Aneurysm'
  },
  {
    label: 'Arrhythmia (irregular heartbeat)',
    value: 'Arrhythmia (irregular heartbeat)'
  },
  {
    label: 'Arthritis',
    value: 'Arthritis'
  },
  {
    label: 'Biliary Disease',
    value: 'Biliary Disease'
  },
  {
    label: 'Bipolar Disorder',
    value: 'Bipolar Disorder'
  },
  {
    label: 'Blindness',
    value: 'Blindness'
  },
  {
    label: 'Bowel Infarction',
    value: 'Bowel Infarction'
  },
  {
    label: 'Cancer',
    value: 'Cancer'
  },
  {
    label: 'Cataplexy',
    value: 'Cataplexy'
  },
  {
    label: 'Cataracts',
    value: 'Cataracts'
  },
  {
    label: 'Chronic Pain',
    value: 'Chronic Pain'
  },
  {
    label: 'Cirrhosis',
    value: 'Cirrhosis'
  },
  {
    label: 'Pneumothorax (Collapsed lung)',
    value: 'Pneumothorax (Collapsed lung)'
  },
  {
    label: 'Color Blindness',
    value: 'Color Blindness'
  },
  {
    label: 'Congestive Heart Failure',
    value: 'Congestive Heart Failure'
  },
  {
    label: 'COPD (constricted airway disorder)',
    value: 'COPD (constricted airway disorder)'
  },
  {
    label: 'Coronary Artery Disease',
    value: 'Coronary Artery Disease'
  },
  {
    label: "Crohn's Disease",
    value: "Crohn's Disease"
  },
  {
    label: 'Cryptococcus',
    value: 'Cryptococcus'
  },
  {
    label: 'Cystic Fibrosis',
    value: 'Cystic Fibrosis'
  },
  {
    label: 'Cytomegalovirus',
    value: 'Cytomegalovirus'
  },
  {
    label: 'Depression',
    value: 'Depression'
  },
  {
    label: 'Dermatitis',
    value: 'Dermatitis'
  },
  {
    label: 'Diabetes',
    value: 'Diabetes'
  },
  {
    label: 'Ectopic Pregnancy',
    value: 'Ectopic Pregnancy'
  },
  {
    label: 'Endometriosis',
    value: 'Endometriosis'
  },
  {
    label: 'Epilepsy',
    value: 'Epilepsy'
  },
  {
    label: 'Erectile Dysfunction',
    value: 'Erectile Dysfunction'
  },
  {
    label: 'Esophagitis Inflammation',
    value: 'Esophagitis Inflammation'
  },
  {
    label: 'Gallstone',
    value: 'Gallstone'
  },
  {
    label: 'Glaucoma',
    value: 'Glaucoma'
  },
  {
    label: 'Glomerulonephritis',
    value: 'Glomerulonephritis'
  },
  {
    label: 'Gout (Gouty arthritis)',
    value: 'Gout (Gouty arthritis)'
  },
  {
    label: 'Headache',
    value: 'Headache'
  },
  {
    label: 'Hepatitis A',
    value: 'Hepatitis A'
  },
  {
    label: 'Hepatitis B',
    value: 'Hepatitis B'
  },
  {
    label: 'Hepatitis',
    value: 'Hepatitis'
  }
];

export const vaccinesList = [
  { label: 'Influenza', value: 'Influenza' },
  { label: 'Diphtheria', value: 'Diphtheria' },
  { label: 'Measles', value: 'Measles' },
  { label: 'Mumps', value: 'Mumps' },
  { label: 'Pertussis', value: 'Pertussis' },
  { label: 'Polio', value: 'Polio' },
  { label: 'Rubella', value: 'Rubella' },
  { label: 'Congenital Rubella Syndrome', value: 'Congenital Rubella Syndrome' },
  { label: 'Smallpox', value: 'Smallpox' },
  { label: 'Tetanus', value: 'Tetanus' },
  {
    label: 'Tdap (Tetanus, Diphtheria, Pertussis)',
    value: 'Tdap (Tetanus, Diphtheria, Pertussis)'
  },
  { label: 'Hepatitis A', value: 'Hepatitis A' },
  { label: 'Haemophilus Influenza type B', value: 'Haemophilus Influenza type B' },
  { label: 'Pneumococcal Disease', value: 'Pneumococcal Disease' },
  { label: 'Varicella', value: 'Varicella' },
  { label: 'Pneumococcal Conjugate', value: 'Pneumococcal Conjugate' },
  { label: 'Pneumococcal Polysaccharide', value: 'Pneumococcal Polysaccharide' },
  { label: 'Hepatitis B', value: 'Hepatitis B' },
  { label: 'Meningococcal ACWY', value: 'Meningococcal ACWY' },
  { label: 'Meningococcal B', value: 'Meningococcal B' },
  { label: 'Rotavirus', value: 'Rotavirus' },
  { label: 'Zoster (Shingles)', value: 'Zoster (Shingles)' },
  { label: 'Yellow Fever', value: 'Yellow Fever' },
  { label: 'Typhoid', value: 'Typhoid' },
  { label: 'Rabies', value: 'Rabies' },
  { label: 'Japanese Encephalitis', value: 'Japanese Encephalitis' },
  { label: 'Cholera', value: 'Cholera' },
  { label: 'Anthrax', value: 'Anthrax' },
  { label: 'BCG (Bacillus Calmette-Guerin)', value: 'BCG (Bacillus Calmette-Guerin)' },
  { label: 'Dengue', value: 'Dengue' },
  { label: 'Ebola', value: 'Ebola' },
  { label: 'Covid-19 (Pfizer-BioNTech)', value: 'Covid-19 (Pfizer-BioNTech)' },
  { label: 'Covid-19 (Moderna)', value: 'Covid-19 (Moderna)' },
  { label: 'Covid-19 (Johnson & Johnson)', value: 'Covid-19 (Johnson & Johnson)' },
  { label: 'Covid-19 (AstraZeneca)', value: 'Covid-19 (AstraZeneca)' },
  { label: 'Covid-19 (Sinovac)', value: 'Covid-19 (Sinovac)' },
  { label: 'Covid-19 (Sinopharm)', value: 'Covid-19 (Sinopharm)' },
  { label: 'Covid-19 (Sputnik V)', value: 'Covid-19 (Sputnik V)' }
];

export const dosesList = [
  {
    label: 'One',
    value: 'One'
  },
  {
    label: 'Two',
    value: 'Two'
  },
  {
    label: 'Three',
    value: 'Three'
  },
  {
    label: 'Four',
    value: 'Four'
  },
  {
    label: 'Five',
    value: 'Five'
  },
  {
    label: 'Not sure',
    value: 'Not sure'
  }
];

export const otherProblemsList = [
  {
    label: 'Outpatient care',
    value: 'Outpatient care'
  },
  {
    label: 'Inpatient care',
    value: 'Inpatient care'
  },
  {
    label: 'Intensive care',
    value: 'Intensive care'
  },
  {
    label: 'Palliative care',
    value: 'Palliative care'
  }
];

export const diagnoses = [
  { id: 1, name: 'diag_1', label: 'A.' },
  { id: 2, name: 'diag_2', label: 'B.' },
  { id: 3, name: 'diag_3', label: 'C.' },
  { id: 4, name: 'diag_4', label: 'D.' },
  { id: 5, name: 'diag_5', label: 'E.' },
  { id: 6, name: 'diag_6', label: 'F.' },
  { id: 7, name: 'diag_7', label: 'G.' },
  { id: 8, name: 'diag_8', label: 'H.' },
  { id: 9, name: 'diag_9', label: 'I.' },
  { id: 10, name: 'diag_10', label: 'J.' },
  { id: 11, name: 'diag_11', label: 'K.' },
  { id: 12, name: 'diag_12', label: 'L.' }
];

export const diagnosisPointers = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L'];

export const patientReasons = [
  { value: 'duplicate', label: 'Duplicate' },
  { value: 'wrong_info', label: 'Wrong Info' }
];
